import React from 'react'
import '../../fonts/fonts.css'
import SideBar from '../../containers/SideBar/index'
import PageHeader from '../../components/PageHeader'
import BaremLogo from '../../images/BaremEvalLogo.svg'
import {
  Bg, MainLayout, PageContent,
  TabBar, TabBtn,
  GridCard, GridCardHeader, GridCardTitle, GridCardSubtitle,
  ScaleTable, RowLabelCol, RowLabel,
  ScaleCol, ColHeader, ColHeaderBadge, CellWrapper, Input,
  GridBottomBar, ConfirmBtn,
  RightPanel, NoteCard, NoteIcon, NoteText,
  SelectorCard, SelectorCardTitle, SelectorScaleEval, ValidateBtn,
  SuccessToast,
} from './styledComponents'

const defaultScale = [
  { type: 'B',       version: 'TGD1', values: [50, 50, 45, 40, 35, 35, 33, 30, 25, 20] },
  { type: 'BEA',     version: 'TGD1', values: [50, 45, 40, 35, 30, 30, 25, 25, 23, 20] },
  { type: 'AAC',     version: 'TGD1', values: [30, 30, 30, 25, 25, 25, 20, 20, 20, 20] },
  { type: 'BEA AAC', version: 'TGD1', values: [30, 30, 30, 25, 25, 25, 20, 20, 20, 20] },
  { type: 'B',       version: 'TGD2', values: [50, 50, 45, 40, 35, 35, 33, 30, 25, 20] },
  { type: 'BEA',     version: 'TGD2', values: [50, 45, 40, 35, 30, 30, 25, 25, 23, 20] },
  { type: 'AAC',     version: 'TGD2', values: [30, 30, 30, 25, 25, 25, 20, 20, 20, 20] },
  { type: 'BEA AAC', version: 'TGD2', values: [30, 30, 30, 25, 25, 25, 20, 20, 20, 20] },
]

const ROWS = new Array(10).fill(0).map((_, i) => ({ label: `De ${i * 10 + 1} à ${(i + 1) * 10}`, i }))

const SCALE_DISPLAY_OPTIONS = [
  { value: 'none',  label: 'Ne rien afficher' },
  { value: 'hours', label: "Afficher le nombre d'heures" },
  { value: 'seq',   label: 'Afficher le nombre de séquences' },
]

export default class SetScaleEvalLayout extends React.PureComponent {

  constructor(props) {
    super(props)

    const findElement = (type, version) =>
      props.scale.find(el => el.type === type && el.version === version)

    let sortedScale = [
      findElement('B',       'TGD1'),
      findElement('BEA',     'TGD1'),
      findElement('AAC',     'TGD1'),
      findElement('BEA AAC', 'TGD1'),
      findElement('B',       'TGD2'),
      findElement('BEA',     'TGD2'),
      findElement('AAC',     'TGD2'),
      findElement('BEA AAC', 'TGD2'),
    ]

    let scale = sortedScale.length > 0 && sortedScale[0] ? sortedScale : defaultScale

    if (!scale.find(el => el.version === 'TGD1')) {
      scale.filter(el => el.version == null).forEach(el => { el.version = 'TGD1' })
    }
    if (!scale.find(el => el.version === 'TGD2')) {
      defaultScale.filter(el => el.version === 'TGD2').forEach(el => scale.push(el))
    }
    if (!scale.find(el => el.type === 'BEA AAC' && el.version === 'TGD1')) {
      scale.push(defaultScale.find(el => el.version === 'TGD1' && el.type === 'BEA AAC'))
    }

    const evalScaleDisplayValue = props.evalScaleDisplay || 'hours'
    this.state = { scale, evalScaleDisplayValue, succes: false }
  }

  updateSucess() {
    this.setState({ succes: true })
    setTimeout(() => this.setState({ succes: false }), 2500)
  }

  setNewScale(colIdx, rowIdx, e) {
    const newScale = Object.assign([], this.state.scale)
    newScale.filter(el => el.version === this.props.tgdVersion)[colIdx].values[rowIdx] = parseInt(e.target.value) || 0
    this.setState({ scale: newScale })
  }

  renderScale() {
    const { tgdVersion, setScale } = this.props
    const { scale, evalScaleDisplayValue, succes } = this.state
    const cols = scale.filter(el => el.version === tgdVersion)
    const enableSave = evalScaleDisplayValue !== this.props.evalScaleDisplay

    const currentDisplayOption = evalScaleDisplayValue.includes('seq')   ? SCALE_DISPLAY_OPTIONS[2]
                               : evalScaleDisplayValue.includes('hours') ? SCALE_DISPLAY_OPTIONS[1]
                               : SCALE_DISPLAY_OPTIONS[0]

    return (
      <MainLayout>
        {succes && (
          <SuccessToast>
            ✓ Barème mis à jour avec succès
          </SuccessToast>
        )}

        <PageHeader icon={BaremLogo} title='Barème Éval' subtitle='Configurez les seuils de réussite par permis' />

        <PageContent>

          {/* ── Version tabs ── */}
          <TabBar>
            <TabBtn to='/scaleeval/tgd1' $active={tgdVersion === 'TGD1' ? 1 : 0}>
              TGD 1
            </TabBtn>
            <TabBtn to='/scaleeval/tgd2' $active={tgdVersion === 'TGD2' ? 1 : 0}>
              TGD 2
            </TabBtn>
          </TabBar>

          {/* ── Main row ── */}
          <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'flex-start' }}>

            {/* ── Scale grid card ── */}
            <GridCard style={{ flex: 1 }}>
              <GridCardHeader>
                <div>
                  <GridCardTitle>Grille de barème</GridCardTitle>
                  <GridCardSubtitle>— version {tgdVersion}</GridCardSubtitle>
                </div>
                <span style={{ fontFamily: 'Poppins', fontSize: '0.75rem', color: '#9CA3AF' }}>
                  Valeurs en heures ou séquences
                </span>
              </GridCardHeader>

              <ScaleTable>
                {/* Row label column */}
                <RowLabelCol>
                  {ROWS.map(({ label, i }) => (
                    <RowLabel key={i}>{label}</RowLabel>
                  ))}
                </RowLabelCol>

                {/* Data columns */}
                {cols.map((col, colIdx) => (
                  <ScaleCol key={col.type + colIdx}>
                    <ColHeader $idx={colIdx}>
                      <ColHeaderBadge $idx={colIdx}>{col.type}</ColHeaderBadge>
                    </ColHeader>
                    {ROWS.map(({ i: rowIdx }) => (
                      <CellWrapper key={rowIdx} $idx={colIdx}>
                        <Input
                          $idx={colIdx}
                          type='number'
                          min={0}
                          value={col.values[rowIdx]}
                          onChange={e => this.setNewScale(colIdx, rowIdx, e)}
                        />
                      </CellWrapper>
                    ))}
                  </ScaleCol>
                ))}
              </ScaleTable>

              <GridBottomBar>
                <ConfirmBtn
                  onClick={() => {
                    setScale(scale, evalScaleDisplayValue)
                    this.updateSucess()
                  }}
                >
                  Confirmer mes barèmes
                </ConfirmBtn>
              </GridBottomBar>
            </GridCard>

            {/* ── Right panel ── */}
            <RightPanel>
              <NoteCard>
                <NoteIcon>💡</NoteIcon>
                <NoteText>
                  Précisez le nombre de séquences prévu selon les scores.
                  Ex&nbsp;: pour «&nbsp;De 81 à 90&nbsp;», saisir «&nbsp;22&nbsp;» pour 22 heures ou 22 séquences.
                </NoteText>
              </NoteCard>

              <SelectorCard>
                <SelectorCardTitle>Affichage dans l'email d'évaluation</SelectorCardTitle>
                <SelectorScaleEval
                  classNamePrefix='react-select'
                  isSearchable={false}
                  value={currentDisplayOption}
                  onChange={opt => this.setState({
                    evalScaleDisplayValue: opt.value
                  })}
                  options={SCALE_DISPLAY_OPTIONS}
                />
                <ValidateBtn
                  $active={enableSave ? 1 : 0}
                  disabled={!enableSave}
                  onClick={() => setScale(scale, evalScaleDisplayValue)}
                >
                  Valider le choix d'affichage
                </ValidateBtn>
              </SelectorCard>
            </RightPanel>

          </div>
        </PageContent>
      </MainLayout>
    )
  }

  render() {
    if (this.props.player == null) {
      return (
        <Bg>
          <SideBar />
          {this.renderScale()}
        </Bg>
      )
    }
  }
}
